var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-app-bar',{staticClass:"main-appbar",attrs:{"flat":"","color":"transparent"}},[_c('app-bar-nav-icon'),_c('v-toolbar-title',{staticClass:"headline font-weight-bold"},[_vm._v("Settings")])],1),_c('router-view',{staticClass:"ml-4"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }